import styled from 'styled-components';
import { FloatingActionsMenu } from '@elementary/common-ui/components';
import { Dashboard } from '@elementary/common-ui/pages';
import ReportEmptyStatePage from 'shared/components/ReportEmptyStatePage';
import ErrorPage from 'app/components/ErrorPage';
import useDashboard from './useDashboard';

const BOTTOM_PADDING = '76px';

const Wrapper = styled.div`
  width: 100%;
  min-height: 100%;
  padding-bottom: ${BOTTOM_PADDING};
`;

const DashboardPage = () => {
  const dashboardData = useDashboard();

  if (dashboardData.error) {
    return (
      <ErrorPage
        error={dashboardData.error as Error}
        errorName={'ApiError'}
        page={'Dashboard'}
      />
    );
  }

  return (
    <Wrapper>
      <Dashboard
        {...dashboardData}
        renderEmptyStatePage={() => <ReportEmptyStatePage />}
        showToggleTreeViewButton
      />
      <FloatingActionsMenu sticky />
    </Wrapper>
  );
};

export default DashboardPage;
